/* eslint-disable prettier/prettier */
import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@techsoftware/happay-widgets/Grid';
import Shimmer from '@techsoftware/happay-widgets/Shimmer';

function CardShimmer(props) {
  return (
    <div className="pos-relative height-190">
      <Shimmer width={320} height={190} mode="light" />
      <Shimmer
        width={100}
        height={16}
        className="pos-absolute-imp top-140 left-20"
      />
      {!props.noLogo && <CardLogo />}
    </div>
  );
}

function CardLogo() {
  return (
    <>
      <Shimmer
        width={30}
        type="circle"
        className="pos-absolute-imp top-140 right-30"
      />
      <Shimmer
        width={30}
        type="circle"
        className="pos-absolute-imp top-140 right-40"
      />
    </>
  );
}

function DashBoardShimmer() {
  return (
    <Grid
      container
      xs={24}
      direction="column"
      alignItems="flex-start"
      className="margin-t-30"
    >
      <Shimmer width={200} height={25} />
      <Shimmer width={300} height={25} className="margin-t-6" />
      <Shimmer width={600} height={50} className="margin-t-20" />
      <Shimmer width={300} height={20} className="margin-t-40" />
      <Shimmer width={600} height={50} className="margin-t-20" />
    </Grid>
  );
}

function TransactionSlipShimmer() {
  return (
    <Shimmer width={120} height={120} className="margin-t-10 margin-r-10" />
  );
}

function ExpenseUpdateViewShimmer() {
  return (
    <Grid>
      <Shimmer width={250} height={15} className="margin-b-30" />
      <Grid container direction="row">
        <TransactionSlipShimmer />
        <TransactionSlipShimmer />
        <TransactionSlipShimmer />
        <TransactionSlipShimmer />
        <TransactionSlipShimmer />
      </Grid>
      <Grid container alignItems="flex-end" justify="flex-end">
        <Shimmer width={126} height={35} className="margin-t-50" />
        <Shimmer width={126} height={35} className="margin-t-50 margin-l-6" />
      </Grid>
    </Grid>
  );
}
function DetailViewShimmer(props) {
  const returnRow = () => {
    const arr = [];
    for (let i = 0; i < props.row; i++) {
      arr.push(
        <Grid
          container
          item
          alignItems="flex-start"
          xs={12}
          direction="column"
          className="margin-b-30"
        >
          <Shimmer width={100} height={15} />
          <Shimmer width={200} height={20} className="margin-t-10" />
        </Grid>,
      );
    }
    return arr;
  };
  return (
    <Grid
      container
      xs={24}
      direction="row"
      className="margin-b-30"
      alignItems="flex-start"
    >
      {returnRow()}
      {!props.cardsView && (
        <>
          <Grid
            container
            item
            alignItems="flex-start"
            xs={12}
            direction="column"
          >
            <Shimmer width={100} height={15} />
            <Grid container item alignItems="flex-start">
              <TransactionSlipShimmer />
              <TransactionSlipShimmer />
              <TransactionSlipShimmer />
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
  );
}

function ChipShimmer() {
  return (
    <>
      <Shimmer width={126} height={30} className="border-radius-16" />
      <Shimmer
        width={126}
        height={30}
        className="margin-l-10 border-radius-16"
      />
    </>
  );
}

function FilterShimmer({ className = '' }) {
  return (
    <div className={className} style={{ float: 'right' }}>
      <Shimmer width={30} height={30} />
    </div>
  );
}

function MerchantRow(props) {
  return (
    <Grid
      container
      direction="row"
      xs={props.hideCheckbox ? 8 : 24}
      alignItems="center"
      className="margin-b-20"
    >
      {!props.hideCheckbox && (
        <Shimmer width={15} height={15} className="margin-l-10 margin-r-20" />
      )}
      <Shimmer width={25} type="circle" />
      <Shimmer width={100} height={12} className="margin-l-10" />
    </Grid>
  );
}

function MerchantShimmer() {
  return (
    <div style={{ marginTop: '-5px' }}>
      <MerchantRow />
      <MerchantRow />
      <MerchantRow />
      <MerchantRow />
      <MerchantRow />
      <MerchantRow />
      <MerchantRow />
      <MerchantRow />
      <MerchantRow />
      <MerchantRow />
    </div>
  );
}

function CardDetailShimmer() {
  return (
    <Grid xs={24}>
      <DetailViewShimmer cardsView />
      <Grid xs={24} container direction="row">
        <MerchantRow hideCheckbox />
        <MerchantRow hideCheckbox />
        <MerchantRow hideCheckbox />
      </Grid>
    </Grid>
  );
}

DetailViewShimmer.propTypes = {
  showUpdate: PropTypes.bool,
  cardsView: PropTypes.bool,
  row: PropTypes.number,
};
DetailViewShimmer.defaultProps = {
  showUpdate: false,
  cardsView: false,
  row: 4,
};

CardShimmer.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  noLogo: PropTypes.bool,
};

MerchantRow.propTypes = {
  hideCheckbox: PropTypes.bool,
};

export {
  CardShimmer,
  CardLogo,
  DashBoardShimmer,
  TransactionSlipShimmer,
  ExpenseUpdateViewShimmer,
  DetailViewShimmer,
  ChipShimmer,
  FilterShimmer,
  MerchantShimmer,
  CardDetailShimmer,
};
